/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_SchedulerService_Dtos_ResponseDto } from '../models/Wealthlane_SchedulerService_Dtos_ResponseDto';
import type { Wealthlane_SchedulerService_Dtos_ScheduleTrigger_PaginatedJobTriggerLogDetailsDto } from '../models/Wealthlane_SchedulerService_Dtos_ScheduleTrigger_PaginatedJobTriggerLogDetailsDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ScheduleTriggerService {

    /**
     * @param scheduleItemId 
     * @returns Wealthlane_SchedulerService_Dtos_ResponseDto OK
     * @throws ApiError
     */
    public static postApiSchedulerApiAppScheduleTriggerActivateSchedule(
scheduleItemId: string,
): CancelablePromise<Wealthlane_SchedulerService_Dtos_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/scheduler/api/app/schedule-trigger/activate-schedule/{scheduleItemId}',
            path: {
                'scheduleItemId': scheduleItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param scheduleItemId 
     * @returns Wealthlane_SchedulerService_Dtos_ResponseDto OK
     * @throws ApiError
     */
    public static postApiSchedulerApiAppScheduleTriggerDisableSchedule(
scheduleItemId: string,
): CancelablePromise<Wealthlane_SchedulerService_Dtos_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/scheduler/api/app/schedule-trigger/disable-schedule/{scheduleItemId}',
            path: {
                'scheduleItemId': scheduleItemId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param scheduleItemId 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns Wealthlane_SchedulerService_Dtos_ScheduleTrigger_PaginatedJobTriggerLogDetailsDto OK
     * @throws ApiError
     */
    public static getApiSchedulerApiAppScheduleTriggerPaginatedJobTriggerLogDetails(
scheduleItemId: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<Wealthlane_SchedulerService_Dtos_ScheduleTrigger_PaginatedJobTriggerLogDetailsDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/scheduler/api/app/schedule-trigger/paginated-job-trigger-log-details/{scheduleItemId}',
            path: {
                'scheduleItemId': scheduleItemId,
            },
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
